import {createCssVar, cssTheme} from '../theme'
import {css} from '../theme/css'
import {breakpoints, spacing} from '../theme/theme'

export const [notificationColor, setNotificationColor] = createCssVar('notification-bg', 'tomato')
export const [notificationShadow, setNotificationShadow] = createCssVar('notification-shadow')

export const classes = {
  toolTip: css`
    z-index: 999;
  `,
  notificationsContainer: css`
    position: fixed;
    display: flex;
    inset-inline-end: ${spacing(2)};
    inset-block-end: ${spacing(2)};
    flex-direction: column-reverse;
    list-style: none;
    z-index: 998;

    ${breakpoints.down('sm')} {
      inset-block-end: ${spacing(10)};
    }
  `,
  notification: css`
    display: grid;
    position: relative;
    grid-template-areas:
      'icon text action-sm close'
      'action-lg action-lg action-lg action-lg';
    grid-template-columns: auto 1fr auto auto;
    gap: ${spacing(0, 2)};
    inline-size: 328px;
    align-items: center;
    margin-block-start: ${spacing(1)};
    padding: ${spacing(1.5, 2)};
    background-color: ${notificationColor};
    box-shadow: ${notificationShadow};
    color: ${cssTheme.default.day.textInvert};
    border-radius: ${spacing(2)};
    touch-action: none;
    transition: left 0.2s linear, opacity 0.2s ease;
    user-select: none;
    ${cssTheme.components.buttons.outline.border.token}: 1px solid ${cssTheme.default.day.textInvert};
    ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};

    ${breakpoints.down('sm')} {
      inline-size: calc(100vi - ${spacing(4)});
    }
  `,
  notificationIcon: css`
    grid-area: icon;
  `,
  notificationText: css`
    grid-area: text;
  `,
  closeNotificationBtn: css`
    all: unset;
    grid-area: close;
    cursor: pointer;
    opacity: 0.5;
    margin-inline-start: auto;
  `,
  expandedClickArea: css`
    position: relative;

    /* Раздвигаем булки чтобы на кнопку было удобнее нажимать */
    &:after {
      content: '';
      position: absolute;
      inset: -${spacing(1)};
    }
  `,
  actionBtnSm: css`
    grid-area: action-sm;
  `,
  actionBtnLg: css`
    margin-block-start: ${spacing(1.5)};
    grid-area: action-lg;
  `,
}
